import * as React from "react";
import {Component} from "react";
import {DashboardFullPeriodCPAVsPeriodCell} from "./DashboardFullPeriodCPAVsPeriodCell";

export class DashboardCurrentCPAVsPeriodCell extends Component {
    render() {
        return <DashboardFullPeriodCPAVsPeriodCell columnData={this.props.data} columnTooltip={this.titleFor()}
                                                   businessUnitId={this.props.businessUnitId}
        />;
    }

    titleFor() {
        return `El CPA actual es de ${this.props.data.formatted_value}. Se espera tener un CPA de ${this.props.data.formatted_expected_value}`;
    }
}
